/**
 * Avertissement permanent sur l'inversion.
 *
 * Ce bloc n'est jamais masquable, et c'est volontaire (§2 du cahier des
 * charges) : l'inversion permute le ratio risque/rendement, et les coûts de
 * transaction, eux, ne s'inversent pas.
 */
export function InversionNotice() {
  return (
    <div className="rounded-lg border border-warn/40 bg-warn/10 p-3 text-[13px] leading-relaxed">
      <p className="mb-1 font-semibold text-warn">Ce que l'inversion change vraiment</p>
      <ul className="space-y-1 text-ink-muted">
        <li>
          Le <strong className="text-ink">Stop Loss saisi devient le Take Profit</strong> réel, et
          inversement : un SL de 20 pips avec un TP de 40 pips devient un risque réel de 40 pips.
        </li>
        <li>
          Le <strong className="text-ink">volume n'est jamais modifié</strong> : seuls le sens et
          les deux niveaux sont permutés.
        </li>
        <li>
          <strong className="text-ink">Spread, commission et swap restent défavorables</strong>{' '}
          dans les deux sens. Inverser une stratégie perdante n'inverse pas les coûts.
        </li>
      </ul>
    </div>
  )
}
